import { render, staticRenderFns } from "./variables.page.vue?vue&type=template&id=6ff2705c&scoped=true&"
import script from "./variables.page.vue?vue&type=script&lang=js&"
export * from "./variables.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2705c",
  null
  
)

export default component.exports